import React, { useContext, useEffect } from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import Diagnostic from "@Screens/Diagnostic/Diagnostic"
import { DiagnosticEducatifList } from "@Screens/Diagnostic/DiagnosticEducatifList"
import { SurveyPage } from "@Screens/Diagnostic/Survey"
import { CustomHeaderComponent } from "@Components/CustomHeader/CustomHeaderComponent"
import UserSettingStack from "@Navigation/UserSettingStack/UserSettingStack"
import DiagnosticConclusion from "@Screens/Home/DiagnosticConclusion/DiagnosticConclusion"
import { useNavigation } from "@react-navigation/native"
import { DiagnosticEducatifContext } from "@Providers/DiagnosticEducatifProvider"
import NoticeConsent from "@Screens/Diagnostic/NoticeConsent/NoticeConsent"
import { AppointmentVisioContent } from "@Screens/FollowUp/Appointment/AppointmentVisioContent"

const MainStackNavigator = createNativeStackNavigator()

export const DiagnosticStack = () => {
    const navigation = useNavigation()
    const { redirectToList } = useContext(DiagnosticEducatifContext)

    useEffect(() => {
        if (!redirectToList) {
            navigation.navigate("Diagnostic")
        }
    }, [redirectToList])

    return (
        <MainStackNavigator.Navigator
            screenOptions={{
                headerShown: true,
                header: (props) => <CustomHeaderComponent {...props} />
            }}
            initialRouteName={"DiagnosticEducatifList"}
        >
            <MainStackNavigator.Screen name="DiagnosticEducatifList" component={DiagnosticEducatifList} />
            <MainStackNavigator.Screen name="NoticeConsent" component={NoticeConsent} />
            <MainStackNavigator.Screen name="Diagnostic" component={Diagnostic} />
            <MainStackNavigator.Screen name="UserSettings" component={UserSettingStack} />
            <MainStackNavigator.Screen name="Survey" component={SurveyPage} />
            <MainStackNavigator.Screen name="DiagnosticConclusion" component={DiagnosticConclusion} />
            <MainStackNavigator.Screen name="AppointmentVisioContent" component={AppointmentVisioContent} />
        </MainStackNavigator.Navigator>
    )
}
